'use client'

import React, {useCallback, useEffect, useRef} from 'react'
import {observer} from 'mobx-react'
import {useRouter} from 'nextjs-toploader/app'
import {FiltersPanel} from '../ui/filters-panel'
import {Routes} from '@/src/config/routes'
import {
  useCatalogFiltersVisibility,
  useFilters,
} from '@/src/features/catalog/filters-v2/containers/csr-filters-provider'
import {navigateToFilters} from '@/src/features/catalog/filters-v2/utils/navigate'
import {usePathname, useSearchParams} from 'next/navigation'
import {getInjection} from '@runlab/di'
import {CatalogEventTypes} from '@/src/core/domain/events/catalog.events'

export const FiltersCsrContainer = observer(function FiltersCsrContainer() {
  const mobileCatalogVisibility = useCatalogFiltersVisibility()
  const mobileVisible = mobileCatalogVisibility?.visible ?? false

  const vm = useFilters()
  const router = useRouter()
  const pendingUrlUpdate = useRef(false)

  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    getInjection('IEventBus').subscribe(CatalogEventTypes.FiltersApply, () => {
      mobileCatalogVisibility?.toggle()
    })
  }, [])

  const handleFilterChange = useCallback(
    (code: string, value: unknown) => {
      if (code === 'category') {
        router.push(Routes.catalog.section.page(value as string))
        return
      }
      pendingUrlUpdate.current = true
      vm.setFilterValue(code, value)
      pendingUrlUpdate.current = false
    },
    [vm, router],
  )

  const handleClearAll = useCallback(() => {
    vm.removeAllFilters()
    navigateToFilters(vm, router, pathname, searchParams)
  }, [vm, pathname, searchParams])

  return (
    <FiltersPanel
      filters={vm.data.filters}
      selectedFilters={vm.data.selectedFilters}
      mobileVisible={mobileVisible}
      onFilterChange={handleFilterChange}
      onClearAll={handleClearAll}
    />
  )
})
